export default __webpack_public_path__ + "static/media/LanceroClosed.87937c9d.jpg";